<template>

  <v-carousel v-if="ready" cycle :interval="7500" hide-delimiter-background show-arrows-on-hover
    transition="fade-transition" :height="carouselHeight">
    <v-carousel-item v-for="(item, i) in items" :key="`slider-item-${i}`">
      <transition name="fade">
        <v-img :src="`${item.src}?v=${version}`" :lazy-src="`${base}/sliders/preview${i + 1}.png?v=${version}`"
          alt="Imagen de slider" class="w-100 h-100" cover>
          <!-- Overlay con degradado y texto -->
          <!-- <div class="overlay d-flex flex-column align-center justify-center text-center">
              <h2 class="overlay-title">Slide {{ i + 1 }}</h2>
              <p class="overlay-text">Texto llamativo o slogan</p>
            </div> -->
        </v-img>
      </transition>
    </v-carousel-item>
  </v-carousel>

</template>

<script>
export default {
  name: 'SliderComponent',
  mounted() {
    Promise.all(
      this.items.map((img, index) => new Promise(resolve => {
        const preload = new Image();
        preload.src = img.src;
        preload.onload = () => {
          this.$set(this.items[index], 'loaded', true);
          resolve();
        };
        preload.onerror = () => resolve();
      }))
    ).then(() => {
      this.ready = true;
    });
  },
  data() {
    const base = process.env.VUE_APP_BASE_IMG;
    const version = new Date().getTime(); // cambia cada vez que recargas la app
    const rawImages = Array.from({ length: 2 }, (_, i) => ({
      src: `${base}/sliders/slider${i + 1}.webp`,
      loaded: false
    }));

    return {
      base,
      items: rawImages,
      ready: false,
      version
    };
  },
  computed: {
    carouselHeight() {
      const bp = this.$vuetify?.breakpoint?.name || 'md';
      switch (bp) {
        case 'xs': return '200px';
        case 'sm': return '300px';
        case 'md': return '300px';
        case 'lg': return '500px';
        case 'xl': return '600px';
        default: return '450px';
      }
    }
  }
};
</script>

<style scoped>
/* Transición fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Overlay degradado */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.2));
  color: white;
  padding: 20px;
}

.overlay-title {
  font-size: 2rem;
  font-weight: bold;
}

.overlay-text {
  font-size: 1.2rem;
  margin-top: 10px;
}
</style>
